import { presetSectionsCodeObject } from "../../../../helpers";

export const preSubmissionTypeDataSource: any = [
  { name: "Fill", value: "Fill" },
  { name: "Modify", value: "Modify" },
];
export const postSubmissionTypeDataSource: any = [
  { name: "Fill", value: "Fill" },
  { name: "Modify", value: "Modify" },
  { name: "Verify", value: "Verify" },
];
export const linkBoqSources: any = {
  INSPECTION_FORM: "inspectionForms",
  LINK_ITEMS: "linkItems",
};
export const formStatuses: any = {
  inProgress: "IN_PROGRESS",
  rejected: "REJECTED",
  approved: "APPROVED",
  submitted: "SUBMITTED",
};
export const formStatusFilterDataSource: any = [
  { name: "In Progress", value: formStatuses.inProgress },
  { name: "Rejected", value: formStatuses.rejected },
  { name: "Approved", value: formStatuses.approved },
  { name: "Submitted", value: formStatuses.submitted },
];

export const formSectionType: any = {
  FORM: "form",
  TABLE_SECTION: "tableSection",
};
export const getUserPermissionForForm = (inspectionData: any, userId: any, sectionIndex: any) => {
  const isCurrentUserAllowed =
    (inspectionData.selectedForm.template[sectionIndex].permissions[inspectionData.currentLevelOfForm].Fill.includes(
      userId,
    ) ||
      inspectionData.selectedForm.template[sectionIndex].permissions[inspectionData.currentLevelOfForm].Modify.includes(
        userId,
      )) &&
    !inspectionData.isRejected &&
    !inspectionData.isApproved &&
    !inspectionData.isArchived.status;

  return isCurrentUserAllowed;
};
export const getFillPermissionForForm = (inspectionData: any, userId: any, sectionIndex: any) => {
  const isCurrentUserAllowed =
    !inspectionData.isRejected &&
    !inspectionData.isApproved &&
    !inspectionData.isArchived.status &&
    inspectionData.selectedForm.template[sectionIndex].permissions[inspectionData.currentLevelOfForm].Fill.includes(
      userId,
    );

  return isCurrentUserAllowed;
};
export const getModifyPermissionForForm = (inspectionData: any, userId: any, sectionIndex: any, modifySection: any) => {
  const sectionId = inspectionData.selectedForm?.template[sectionIndex]?._id;

  const isCurrentUserAllowed =
    !inspectionData.isRejected &&
    !inspectionData.isApproved &&
    !inspectionData.isArchived.status &&
    inspectionData.selectedForm.template[sectionIndex].permissions[inspectionData.currentLevelOfForm].Modify.includes(
      userId,
    ) &&
    !inspectionData.isRejected &&
    !inspectionData.isApproved &&
    !inspectionData.isArchived.status &&
    modifySection?.includes(sectionId);

  return isCurrentUserAllowed;
};

export const getSectionPermission = ({
  section,
  inspectionData,
  userId,
  type,
}: {
  section: any;
  inspectionData: any;
  userId: string;
  type: string;
}) => {
  const isCurrentUserAllowed =
    section.permissions[inspectionData.currentLevelOfForm][type].includes(userId) &&
    !inspectionData.isArchived.status &&
    !inspectionData.isRejected &&
    !inspectionData.isApproved;

  return isCurrentUserAllowed;
};
export const getPermissions = ({
  inspectionData,
  permissions = {},
  type,
  userId,
}: {
  inspectionData: any;
  permissions: any;
  type: string;
  userId: string;
}) => {
  if (typeof permissions == "object" && !Object.keys(permissions).length) {
    return true;
  }
  if (inspectionData.isApproved || inspectionData.isRejected || inspectionData.isArchived?.status) {
    return false;
  }
  return permissions[inspectionData.currentLevelOfForm][type].includes(userId);
};

export const onURLClick = (url: any) => {
  const newUrl = /^(https?:)?\/\//i.test(url) ? url : `https://${url}`;
  return newUrl;
};

const getTextRules = (field: any) => {
  return {
    minLength: field.minFieldLimit ?? 0,
    ...(field.maxFieldLimit && { maxLength: field.maxFieldLimit }),
  };
};

const getNumberRules = (field: any) => {
  return {
    minRange: field.minFieldRange ?? 0,
    ...(field.maxFieldRange && { maxRange: field.maxFieldRange }),
  };
};

const getFileRules = (field: any) => {
  return {
    ...(field.maxNoOfFiles && { maxNoOfFiles: field.maxNoOfFiles }),
    ...(field.isMandatory && field.minNoOfFiles && { minNoOfFiles: field.minNoOfFiles }),
  };
};

const getDateTimeRules = (field: any) => {
  const rules: any = {
    ...(field.maxFieldRange && { maxFieldRange: field.maxFieldRange }),
    ...(field.minFieldRange && { minFieldRange: field.minFieldRange }),
  };
  if (["futureDateTime", "pastDateTime"].includes(field.selectionScope)) {
    rules.selectionScope = field.selectionScope;
  }
  return rules;
};

const generateRuleObj = (eachField: any, row?: any) => {
  const value = (row ? row[eachField._id]?.value : eachField.answer?.value) ?? "";

  let ruleObj: any = {};

  if (eachField.isMandatory) {
    ruleObj.required = true;
  }

  switch (eachField.fieldType) {
    case "single-line":
    case "multi-line":
      ruleObj = { ...ruleObj, ...getTextRules(eachField) };
      break;
    case "number":
      ruleObj = { ...ruleObj, ...getNumberRules(eachField) };
      break;
    case "fileUpload":
    case "image":
      ruleObj = { ...ruleObj, ...getFileRules(eachField) };
      break;
    case "date-time":
      ruleObj = { ...ruleObj, ...getDateTimeRules(eachField) };
      break;
  }

  return { ...ruleObj, value };
};

export function addValidationToForms({
  formValidator,
  template = [],
  inspectionData,
  rows,
  modifySection = [],
}: {
  formValidator: any;
  template?: any;
  inspectionData?: any;
  rows?: any;
  modifySection?: any;
}) {
  const allSectionsInCurrentLevel: any = [];
  if (inspectionData?._id) {
    inspectionData.formFlow[inspectionData.currentLevelOfForm].dataSource.map((data: any) => {
      if (data.type === "Fill") {
        data.sections.map((section: any) => allSectionsInCurrentLevel.push(section._id));
      } else if (data.type === "Modify") {
        data.sections.map((section: any) => {
          if (modifySection.includes(section._id)) {
            allSectionsInCurrentLevel.push(section._id);
          }
        });
      }
    });
    template = inspectionData.selectedForm.template;
  } else if (template?.length) {
    template?.forEach((section: any) => {
      allSectionsInCurrentLevel.push(section._id);
    });
  }
  const options: any = { rules: {} };
  template?.forEach((section: any) => {
    if (
      section.sectionCode === presetSectionsCodeObject.SECTION_TYPE_TABLE_SECTION &&
      allSectionsInCurrentLevel.includes(section._id)
    ) {
      section.questionFields.forEach((eachField: any) => {
        section.tableDataSource.forEach((row: any) => {
          const ruleName: string = `${row.rowId}${eachField._id}`;
          const rulesObj: any = generateRuleObj(eachField, row);
          options.rules[ruleName] = {
            ...rulesObj,
          };
        });
      });
    } else if (section.questionFields && allSectionsInCurrentLevel.includes(section._id)) {
      section.questionFields.forEach((eachField: any) => {
        const ruleName = `${eachField._id}`;
        const rulesObj: any = generateRuleObj(eachField);
        if (rows) {
          rows.forEach((row: any) => {
            if (!row.isFolder) {
              options.rules[`${row.id}_${ruleName}`] = {
                ...rulesObj,
              };
            }
          });
        } else {
          options.rules[ruleName] = {
            ...rulesObj,
          };
        }
      });
    }
  });
  formValidator.updateRules(options.rules);
}

export function checkMandatoryFields(inspectionData: any) {
  const allSectionsInCurrentLevel: any = [];
  inspectionData.formFlow[inspectionData.currentLevelOfForm].dataSource.map((data: any) => {
    data.sections.map((section: any) => allSectionsInCurrentLevel.push(section._id));
  });
  let errorToastContent = "Form submission failed: Not all mandatory fields filled.";
  let isAllMandatoryFieldsFilled = true;

  const isEmptyValue = (value: any) => {
    if (["", undefined, null].includes(value)) return true;
    if (Array.isArray(value)) return value.join("").trim() === "";
    if (typeof value === "object" && Object.keys(value).length === 0) return true;
    return false;
  };

  const validateMandatory = (isMandatory: boolean, value: any) => {
    if (isMandatory && isEmptyValue(value)) {
      isAllMandatoryFieldsFilled = false;
      return true;
    }
    return false;
  };

  const validateTextField = (field: any, value: any) => {
    if (!["single-line", "multi-line"].includes(field.fieldType) || !value?.length) return false;

    if (field.minFieldLimit > value.length) {
      isAllMandatoryFieldsFilled = false;
      return true;
    }
    if (field.maxFieldLimit && value.length > field.maxFieldLimit) {
      isAllMandatoryFieldsFilled = false;
      return true;
    }
    return false;
  };

  const validateDateTime = (field: any, value: any) => {
    if (field.fieldType !== "date-time") return false;

    if (field.selectionScope === "pastDateTime" && value && value > Date.now()) {
      errorToastContent = "Form submission failed: Please select a date and time from the past";
      isAllMandatoryFieldsFilled = false;
      return true;
    }

    if (
      field.selectionScope === "rangeBased" &&
      ((field.minFieldRange && value && value < field.minFieldRange) ||
        (field.maxFieldRange && value && value > field.maxFieldRange))
    ) {
      errorToastContent = "Form submission failed: Please select a date and time within the predefined range";
      isAllMandatoryFieldsFilled = false;
      return true;
    }

    return false;
  };

  const validateFiles = (field: any, value: any) => {
    if (!Array.isArray(value)) return false;

    if (field.isMandatory && field.minNoOfFiles && field.minNoOfFiles > value.length) {
      isAllMandatoryFieldsFilled = false;
      return true;
    }

    if (field.maxNoOfFiles && value.length > field.maxNoOfFiles) {
      isAllMandatoryFieldsFilled = false;
      errorToastContent = "Form submission failed: Files uploaded exceeds the max limit set for this field";
      return true;
    }

    return false;
  };

  const generateRule = (eachField: any, row?: any) => {
    const answerValue = (row ? row[eachField._id]?.value : eachField.answer?.value) ?? "";

    return (
      validateMandatory(eachField.isMandatory, answerValue) ||
      validateTextField(eachField, answerValue) ||
      validateDateTime(eachField, answerValue) ||
      validateFiles(eachField, answerValue)
    );
  };

  inspectionData.selectedForm.template?.some((section: any) => {
    if (
      section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_TABLE_SECTION &&
      allSectionsInCurrentLevel.includes(section._id)
    ) {
      section.questionFields.some((eachField: any) => {
        if (section?.tableDataSource?.length) {
          section.tableDataSource.some((row: any) => {
            return generateRule(eachField, row);
          });
        } else {
          return generateRule(eachField);
        }
      });
    } else if (section.questionFields && !section.sectionCode && allSectionsInCurrentLevel.includes(section._id)) {
      section.questionFields.some((eachField: any) => {
        return generateRule(eachField);
      });
      return !isAllMandatoryFieldsFilled;
    }
    return false;
  });
  return {
    errorToastContent,
    isAllMandatoryFieldsFilled,
  };
}
export const getRoleIdDescriptionMapperForForms: any = (t: any) => {
  return {
    1: t("Can fill or change form content as defined in the form flow."),
    4: t("Can view and export."),
    6: t("Cannot export or update."),
    7: t("Cannot view, export or update."),
  };
};
export const getRoleIdNameMapperForForms: any = (t: any) => {
  return {
    1: t("Full Access"),
    4: t("Can Download"),
    6: t("Can View"),
    7: t("No access"),
  };
};
